"use client";

import { z } from "zod";

export type ExpenseAndIncomeCategorySchemaType = z.infer<
  typeof expenseAndIncomeCategorySchema
>;
export type ExpenseAndIncomeSubCategorySchemaType = z.infer<
  typeof expenseAndIncomeSubCategorySchema
>;
export type ExpenseAndIncomeTypeSchemaType = z.infer<
  typeof expenseAndIncomeTypeSchema
>;

export const expenseAndIncomeCategorySchema = z.object({
  name: z.string().min(1, { message: "Required" }),
  color: z.string().min(1, { message: "Required" }),
});

export const expenseAndIncomeSubCategorySchema = z.object({
  name: z.string().min(1, { message: "Required" }),
});

export const expenseAndIncomeTypeSchema = z.object({
  name: z.string().min(1, { message: "Required" }),
  color: z.string().min(1, { message: "Required" }),
  type: z.enum(["expense", "income"], {
    required_error: "Required",
    invalid_type_error: "Required",
  }),
});
